import img29part2 from '@/assets/img/news/29_2.webp';
import img29part3 from '@/assets/img/news/29_3.webp';

export default {
  date: 'October 18, 2024',
  title: 'New window customization options: choose the color of the frame and glass',
  description: 'Getfloorplan now offers expanded options for users ordering layouts.',
  id: 'window-customization-options',
  jsx: () => (
    <>
      <div class='novelty__text'>
        <p>Getfloorplan now offers expanded options for users ordering layouts.</p>
        <p>In addition to choosing between panoramic or standard windows, you can specify your preferences for frame and glass colors in the comments section of your order. This ensures that the windows perfectly match the design of your interior or exterior.</p>
      </div>
      <div class='novelty__thumb'>
        <img alt='news img' src={img29part2} />
      </div>
      <div class='novelty__text'>
        <b>1. Frame Color</b>
        <p>Users can request a change in window frame color by selecting one of the following options:</p>
        <li class='margin-none'>
          <b>White</b> — a universal option suitable for any interior.
        </li>
        <li class='margin-none'>
          <b>Brown</b> — a warm shade that fits well with classic or rustic styles.
        </li>
        <li class='margin-none'>
          <b>Metallic</b> — a modern solution for minimalist or industrial designs.
        </li>
        <li>
          <b>Mirror metallic</b> — a striking choice for contemporary and futuristic projects.
        </li>
      </div>
      <div class='novelty__thumb'>
        <img alt='news img' src={img29part3} />
      </div>
      <div class='novelty__text'>
        <b>2. Glass Color</b>
        <p>You can also specify your preferences for glass color in the order:</p>
        <li class='margin-none'>
          <b>Clear</b> — a standard option for maximum light penetration.
        </li>
        <li class='margin-none'>
          <b>Black</b> — a stylish choice to reduce brightness and add a modern touch.
        </li>
        <li class='margin-none'>
          <b>Tinted</b> — for sun protection and a more comfortable atmosphere.
        </li>
        <li>
          <b>Frosted</b> — ideal for privacy while maintaining light.
        </li>
        <p>
          With Getfloorplan, you can now not only select the type of windows but also specify your preferences for frame and glass colors, ensuring your project aligns with your style. Take advantage of this option by adding your details in the comments section of your order, and receive a layout
          that fits perfectly into your interior. Realize your unique ideas with Getfloorplan — we’ll help you create the space of your dreams!
        </p>
      </div>
    </>
  ),
  thumb: 'news/29_1.webp',
};
